import Crud from './crud'
import { request_list } from '@/commons/hpod';
import Vue from 'vue';
var crud = new Crud('users', 'tài khoản');

const state = {
    ...crud.state,
    debt: {},
    selected: {
        id: 0
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    getDebt({ commit }, param) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                commit("setLoading", { loading: true });
                request_list('users/debt', item => {
                    commit('setDebt', item);
                    commit("setLoading", { loading: false });
                    resolve(item.data ? item.data : item);
                }, param, this.state.authentication.token);
            }, 100)
        })
    },
};
const mutations = {
    ...crud.mutations,
    setDebt(state, data) {
        state.debt = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};